import React, { forwardRef } from 'react';
import BlockContainer from 'Components/landings/BlockContainer';
import { colors } from 'constants/colors';
import { Flex, Box } from '@igooods/ui-kit';
import { mediaSmDown, mediaMdDown } from 'theme/helpers/css';
import styled from 'styled-components';
import Title from 'Components/Typography/Title';
import { FontFamily } from 'theme';
import rightBlob from './images/blob-right.svg';
import leftBlob from './images/blob-left.svg';
import SearchAddress, { IGtagOptions } from 'Components/landings/LandingSearchAddress/SearchAddressBlock';
import { GtagFrom, IBlockWithDevice } from '../types';
import { EnumInputTheme } from 'constants/enums';

const Wrapper = styled(BlockContainer)`
  background-image: url(${rightBlob}), url(${leftBlob});
  background-position: 100% 0%, -1% 113%;
  background-repeat: no-repeat;
  background-size: auto 81%, auto 72%;

  ${mediaMdDown`
    background-position: 103% -45%, -3% 163%;
  `}

  ${mediaSmDown`
    background-image: none;
  `}
`;

const Content = styled(Flex).attrs({
  pt: { xs: 14, sm: 20, lg: 30 },
  pb: {
    xs: 15,
    sm: 26,
    lg: 42,
  },
  center: true,
  column: true,
  middle: true,
})`
  width: 100%;
  max-width: 580px;
  margin-right: auto;
  margin-left: auto;

  ${mediaMdDown`
    max-width: 540px;
  `}
`;

const BlockTitle = styled(Title).attrs({
  center: true,
  level: '2',
  fontFamily: FontFamily.secondFont,
  color: colors.blackRussian,
})`
  text-align: center;

  ${mediaMdDown`
    font-size: 20px;
    line-height: 30px;
  `}

  ${mediaSmDown`
    font-size: 20px;
    line-height: 30px;
    text-align: left;
    max-width: 400px;
  `}
`;

const SearchAddressContainer = styled(Box).attrs({
  mt: { xs: 8, lg: 15 },
})`
  max-width: 580px;

  ${mediaMdDown`
    max-width: 540px;
  `}

  ${mediaSmDown`
    width: 100%;
  `}
`;

const Br = styled.br`
  ${mediaSmDown`
    display: none;
  `}
`;

const Delivery = forwardRef<HTMLDivElement, IBlockWithDevice>(({ device, ...props }, ref) => {
  const gtagOptions: IGtagOptions = {
    click_map_properties: { from: GtagFrom.YELLOW_BANNER },
    click_call_to_action_properties: { from: GtagFrom.YELLOW_BANNER, device },
  };

  return (
    <Wrapper bgColor={colors.bananaFlavouredLemonade} ref={ref} {...props}>
      <Content>
        <h3>
          <BlockTitle>
            Доставим продукты cегодня. <Br />
            Домой или в&nbsp;офис
          </BlockTitle>
        </h3>
        <SearchAddressContainer>
          <SearchAddress use={EnumInputTheme.round} gtagOptions={gtagOptions} />
        </SearchAddressContainer>
      </Content>
    </Wrapper>
  );
});

Delivery.displayName = 'Delivery';

export default Delivery;
